export default __webpack_public_path__ + "static/media/ictLogo.1b51398e.svg";